<ng-template #popContent let-description="description">
  <div [innerHTML]="description"></div>
</ng-template>

<div *ngFor="let perm of options?.capabilities">
  <div class='form-check'>
    <input
      (ngModelChange)="togglePerm(perm)"
      [disabled]="isDisabled"
      [id]="'P_' + perm.key"
      [ngModel]="!!selectedPermission && selectedPermission?.includes(perm.key)"
      class='form-check-input'
      type='checkbox'
    >
    <label [for]="'P_' + perm.key" class='form-check-label'>
      {{ perm.name }}
    </label>
    <pt-icon
      #p1="ngbPopover" (click)="toggleWithGreeting(p1, perm.description)"
      *ngIf="perm.description"
      [key]='iconInfo'
      [ngbPopover]="popContent"
      [popoverClass]="'input-help-popover'"
      class='permission-help'
      placement="end"
      triggers="manual"
    ></pt-icon>
  </div>
</div>
